<template>
  <div class="grid-column-start-2_sm grid-column-end-4_sm flex flex-column justify-items-center vh75">
    <header class="my2">
      <h1 class="font-size-8">Ready?</h1>
      <h2>Let&rsquo;s analyze your rates</h2>
    </header>
    <p>
      <router-link
        :to="{ name: 'rate', params: { id: rate.id }, query: { s: '1' }}"
        :class="'button large-button accent-button full-button_mb'">See your new rate card</router-link>
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      page: this.$route.params.id
    }
  },
  computed: {
    rate () {
      return this.$store.getters.rateCard(this.page)
    }
  }
}
</script>
